import Project from '../../models/Project';
import {
  IndicatorProjectQueriesActionTypes,
  INDICATOR_PROJECT_QUERY_STARTED,
  INDICATOR_PROJECT_QUERY_SUCCEEDED,
  INDICATOR_PROJECT_QUERY_FAILED,
  RESET_INDICATOR_PROJECT_QUERY,
  RESET_INDICATOR_PROJECT_QUERIES,
} from './types';

// Callers provide a unique requestId for each attempt, including retries.
export const startIndicatorProjectQuery = (
  queryKey: string,
  requestId: string,
): IndicatorProjectQueriesActionTypes => ({
  type: INDICATOR_PROJECT_QUERY_STARTED,
  payload: { queryKey, requestId },
});

export const succeedIndicatorProjectQuery = (
  queryKey: string,
  requestId: string,
  data: Project[],
): IndicatorProjectQueriesActionTypes => ({
  type: INDICATOR_PROJECT_QUERY_SUCCEEDED,
  payload: { queryKey, requestId, data },
});

export const failIndicatorProjectQuery = (
  queryKey: string,
  requestId: string,
  error: string,
): IndicatorProjectQueriesActionTypes => ({
  type: INDICATOR_PROJECT_QUERY_FAILED,
  payload: { queryKey, requestId, error },
});

export const resetIndicatorProjectQuery = (queryKey: string): IndicatorProjectQueriesActionTypes => ({
  type: RESET_INDICATOR_PROJECT_QUERY,
  payload: { queryKey },
});

export const resetIndicatorProjectQueries = (): IndicatorProjectQueriesActionTypes => ({
  type: RESET_INDICATOR_PROJECT_QUERIES,
});
